import React from 'react';

interface OtherModifierItemProps {
  name: string;
  type: string;
  count: number;
}

export const OtherModifierItem: React.FC<OtherModifierItemProps> = ({ name, type, count }) => {
    // Determine color based on type for visual distinction
    const typeColor = 
        type === 'Anvil' ? 'text-amber-500' :
        type === 'Morgana' ? 'text-purple-400' :
        type === 'Merlin' ? 'text-blue-400' : 'text-gray-400';

    const borderColor = 
        type === 'Anvil' ? 'border-amber-900/50' :
        type === 'Morgana' ? 'border-purple-900/50' :
        type === 'Merlin' ? 'border-blue-900/50' : 'border-slate-700';

  return (
    <div className={`
        flex items-center p-1 rounded border bg-slate-900/60 ${borderColor} h-10 w-full overflow-hidden
        select-none
    `}>
        {/* Placeholder Icon / Initial */}
        <div className={`w-8 h-8 shrink-0 mr-2 bg-slate-950 rounded border border-slate-800 flex items-center justify-center font-serif font-bold ${typeColor}`}>
            {type.charAt(0)}
        </div>
        
        <div className="flex flex-col min-w-0 flex-1">
            <span className={`text-[10px] uppercase font-bold leading-none mb-0.5 ${typeColor} opacity-70`}>{type}</span>
            <span className="text-xs text-slate-200 font-medium truncate leading-none">{name}</span>
        </div>

        {count > 1 && (
            <div className="ml-1 px-1.5 py-0.5 bg-slate-800 rounded text-[10px] font-mono text-white border border-slate-600">
                x{count}
            </div>
        )}
    </div>
  );
};

export default OtherModifierItem;
